export function isElement(node) {
  return node !== null && node.nodeType === node.ELEMENT_NODE;
}
export function isHTMLTableCaptionElement(node) {
  return isElement(node) && node.tagName === "CAPTION";
}
export function isHTMLInputElement(node) {
  return isElement(node) && node.tagName === "INPUT";
}
export function isHTMLSelectElement(node) {
  return isElement(node) && node.tagName === "SELECT";
}
export function isHTMLTableElement(node) {
  return isElement(node) && node.tagName === "TABLE";
}
export function isHTMLTextAreaElement(node) {
  return isElement(node) && node.tagName === "TEXTAREA";
}
export function safeWindow(node) {
  var _ref = node.ownerDocument === null ? node : node.ownerDocument,
      defaultView = _ref.defaultView;

  if (defaultView === null) {
    throw new TypeError("no window available");
  }

  return defaultView;
}
export function isHTMLFieldSetElement(node) {
  return isElement(node) && node.tagName === "FIELDSET";
}
export function isHTMLLegendElement(node) {
  return isElement(node) && node.tagName === "LEGEND";
}
//# sourceMappingURL=util.mjs.map